module.exports = __webpack_public_path__ + "static/faktum-semibold-61fc6284e1b1019997649181e53d65e3.woff2";